import { configureStore } from '@reduxjs/toolkit';
import adminReducer from '../reducers/adminSlice';
import securityReducer from '../reducers/securitySlice';
import notifyReducer from '../reducers/notifySlice';
import sidebarReducer from '../reducers/sidebarSlice';
import settingReducer from '../reducers/settingSlice';
import userReducer from '../reducers/userSlice';
import cartReducer from '../reducers/cartSlice';
import configReducer from '../reducers/configSlice';
import userItemApprovalSlice from '../reducers/userItemApprovalSlice';
import contentFilterSlice from '../reducers/contentFilterSlice';

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    security: securityReducer,
    notify: notifyReducer,
    sidebar: sidebarReducer,
    setting: settingReducer,
    user: userReducer,
    cart:cartReducer,
    config:configReducer,
    userItemApproval:userItemApprovalSlice,
    contentFilter:contentFilterSlice
  },
});
